<form #methodsForm="ngForm">
  <div class="row property-container"> 
    <div  class="col-xs-3 tab-content">
  <div (click)="showMethods = !showMethods" class="property-list">
    <div class="panel-heading">
      <h4 class="panel-title">
        <span accordion-heading>
         <button  class="wm-icon fa" [ngClass]="{'fa-caret-right': !showMethods, 'fa-caret-down': showMethods}"></button> {{locale.LABEL_PREFAB_PROPS_METHODS}}
          <button type="button" class="btn btn-sm app-button button-primary float-right add-property" (click)="addMethod($event)" title="{{locale.TITLE_PREFAB_PROPS_ADD_METHOD}}">{{locale.LABEL_ADD}}</button>
        </span>
        </h4>
        </div>
    <div *ngIf="showMethods" class="panel-body">
      <p class="no-prop-message" *ngIf="noMethodsAvailable">{{locale.MESSAGE_NO_METHODS_EXIST}}</p>
      <ul class="list-items properties" *ngIf="!noMethodsAvailable" id="methods">
        <li class="list-item"
            *ngFor="let method of methods; let index = index;"
            [ngClass]="{'active': index===selectedMethodIndex, 'bg-danger': method['invalid']}"
            (click)="$event.stopPropagation(); selectMethod(method, index)">
          <div class="item">
            <span class="title" title="{{method.name || method.tempName}}">{{method.name || method.tempName}}</span>
            <button type="button" class="btn app-button btn-transparent btn-delete float-right" (click)="$event.stopPropagation(); removeMethod(method)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_METHOD}}">
              <i class="wm-icon wms wms-delete"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
  </div>
  <div *ngIf="!noMethodsAvailable" class="col-md-9 tab-content">
    <div class="secondary-panel properties-tab">
    <h5>{{locale.LABEL_GENERAL}}</h5>
    <div class="form-group app-composite-widget clearfix">
      <label class="app-label col-xs-3 required">{{locale.LABEL_NAME}}</label>
      <i placement="right" tooltip="{{locale.LABEL_PREFAB_PROPS_METHOD_NAME_PLACEHOLDER}}" [tooltipAppendToBody]="true" class="wm-icon wms wms-help help-text-icon"></i>
      <i *ngIf="methodName.touched && (selectedMethod['nameInvalid'] || methodName['invalid'])" class="wms wms-error-outline" title="{{locale.LABEL_PREFAB_PROPS_METHOD_NAME_PLACEHOLDER}}"></i>
      <input class="form-control col-xs-6" [ngClass]="{'error ng-invalid': selectedMethod['nameInvalid']}"
             title="{{locale.LABEL_PREFAB_PROPS_METHOD_NAME_PLACEHOLDER}}" placeholder="{{locale.LABEL_PREFAB_PROPS_METHOD_NAME_PLACEHOLDER}}" pattern="^\w*$" name="methodName" #methodName="ngModel"
             [(ngModel)]="selectedMethod.name" [ngModelOptions]="{updateOn: 'change'}"
             (change)="validateFields(selectedMethod, 'name')" required>
    </div>

    <div class="form-group app-composite-widget clearfix">
      <label class="app-label col-xs-3 required">{{locale.LABEL_DESCRIPTION}}</label>
      <i placement="right" tooltip="{{locale.LABEL_PREFAB_PROPS_METHOD_DESC_PLACEHOLDER}}" [tooltipAppendToBody]="true" class="wm-icon wms wms-help help-text-icon"></i>
      <i *ngIf="methodDesc.touched && methodDesc.invalid" class="wms wms-error-outline" title="{{locale.MESSGAE_FILL_OUT_FIELD}}"></i>
      <textarea class="form-control col-xs-6 app-textarea pty-textarea" #methodDesc="ngModel"
                [(ngModel)]="selectedMethod['description']" [ngModelOptions]="{updateOn: 'change'}"
                (change)="validateFields(selectedMethod, 'description')"
                title="{{locale.LABEL_PREFAB_PROPS_METHOD_DESC_PLACEHOLDER}}" placeholder="{{locale.LABEL_PREFAB_PROPS_METHOD_DESC_PLACEHOLDER}}" rows="5" name="methodDesc" required></textarea>
    </div>

    <div class="form-group app-composite-widget clearfix">
      <label class="control-label col-xs-3">{{locale.LABEL_PREFAB_METHOD_RETURN_TYPE}}</label>
      <i placement="right" tooltip="{{locale.MESSAGE_HELP_PREFAB_METHOD_RETURN_TYPE}}" [tooltipAppendToBody]="true"  class="wm-icon wms wms-help help-text-icon"></i>
      <select class="col-xs-6 app-select form-control" title="{{locale.MESSAGE_HELP_PREFAB_METHOD_RETURN_TYPE}}"
              [(ngModel)]="selectedMethod.returnType" name="method-returnType">
        <option *ngFor="let returnType of returnTypes" [ngValue]="returnType">{{returnType}}</option>
      </select>
    </div>
    <hr>
    <h5>
      {{locale.LABEL_PARAMS}}
      <button type="button" class="btn btn-sm app-button button-primary float-right add-property" (click)="addNewMethodParam(selectedMethod)">{{locale.LABEL_ADD}}</button>
    </h5>
    <table class="properties-table method-params wm-table header-fixed">
      <thead>
      <tr>
        <th class="app-label param-name">{{locale.LABEL_NAME}}</th>
        <th class="app-label param-type">{{locale.LABEL_TYPE}}</th>
        <th class="app-label param-desc">{{locale.LABEL_DESCRIPTION}}</th>
        <th class="pty-delete"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let param of selectedMethod.parameters; let index = index;">
        <td>
          <input class="app-textbox form-control" pattern="^\w*$" required [name]="'param-name' + index"
                 title="{{locale.LABEL_PREFAB_METHOD_PARAM_NAME_PLACEHOLDER}}" placeholder="{{locale.LABEL_PREFAB_METHOD_PARAM_NAME_PLACEHOLDER}}"
                 [(ngModel)]="param.name" [ngModelOptions]="{updateOn: 'change'}">
        </td>
        <td>
          <select class="app-select form-control" title="{{locale.LABEL_PREFAB_METHOD_PARAM_TYPE_PLACEHOLDER}}" [name]="'param-type' + index"
                  [(ngModel)]="param.type" [ngModelOptions]="{updateOn: 'change'}">
            <option *ngFor="let paramType of paramTypes" [ngValue]="paramType">{{paramType}}</option>
          </select>
        </td>
        <td>
          <input class="app-textbox form-control" title="{{locale.LABEL_PREFAB_METHOD_PARAM_DESC_PLACEHOLDER}}" placeholder="{{locale.LABEL_PREFAB_METHOD_PARAM_DESC_PLACEHOLDER}}"
                 [(ngModel)]="param.description" [ngModelOptions]="{updateOn: 'change'}" [name]="'param-desc' + index">
        </td>
        <td>
          <button type="button" class="btn app-button btn-transparent" (click)="removeMethodParam(param, selectedMethod)" title="{{locale.TITLE_PREFAB_PROPS_DELETE_PARAMETER}}">
            <i class="wm-icon wms wms-delete"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
  </div>
</form>
